// empty basics
export const EMPTY_ARR = Object.freeze([]);
export const EMPTY_OBJ = Object.freeze({});
export const EMPTY_PROMISE = (...args) =>
  new Promise((resolve) => {
    window.setTimeout(() => {
      resolve(...args);
    });
  });
export const EMPTY_PROMISE_FAILURE = (error) =>
  new Promise((resolve, reject) => {
    window.setTimeout(() => {
      reject(error);
    });
  });
